import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default function initHeader() {
  const headerMain = document.querySelector(".header-main")
  const mainElement = document.querySelector(".main")
  const darkHero = document.querySelector(".hero--dark")
  const heroBckg = document.querySelector(".hero__bckg")

  // Keep body scrolled on the right position when mobile menu is open (not scroll to top)
  const navBurgerWrapper = document.querySelector("#burger")
  const mainMenu = document.querySelector(".header-main__nav")
  let scrollPosition = 0

  const isLight = darkHero !== null || headerMain.dataset.forceLight === "1"

  navBurgerWrapper.addEventListener("click", () => {
    if (mainMenu.classList.contains("main-nav--open")) {
      // Close the menu
      mainMenu.classList.remove("main-nav--open")
      document.body.style.position = ""
      document.body.style.top = ""
      document.body.style.width = ""

      // Temporarily disable smooth scrolling
      document.documentElement.style.scrollBehavior = "auto"
      window.scrollTo(0, scrollPosition)
      // Re-enable smooth scrolling
      document.documentElement.style.scrollBehavior = ""
    } else {
      // Open the menu
      scrollPosition = window.scrollY
      mainMenu.classList.add("main-nav--open")
      document.body.style.position = "fixed"
      document.body.style.top = `-${scrollPosition}px`
      document.body.style.width = "100%"
    }
  })

  // Handle anchor link clicks
  const navLinks = document.querySelectorAll(".header-main__nav a[href^='#']")
  navLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault()
      const targetId = link.getAttribute("href").substring(1)
      const targetElement = document.getElementById(targetId)

      if (targetElement) {
        // Close the menu and reset body styles
        mainMenu.classList.remove("main-nav--open")
        document.body.style.position = ""
        document.body.style.top = ""
        document.body.style.width = ""

        // Scroll to the target element
        const offset = 100 // Adjust this value as needed
        const targetPosition =
          targetElement.getBoundingClientRect().top + window.scrollY - offset
        window.scrollTo({ top: targetPosition, behavior: "smooth" })
      }
    })
  })

  // Function to handle scroll event
  function handleScroll() {
    // Check if the .hero__bckg element exists
    if (heroBckg) {
      // Get the height of the .hero__bckg element
      const heroBckgHeight = heroBckg.offsetHeight

      // Check if the scroll position is within the height of the .hero__bckg element
      if (window.scrollY <= heroBckgHeight) {
        headerMain.classList.add("header-main--light")
      }
    }

    if (window.scrollY >= 100) {
      headerMain.classList.add("header-main--white")
    } else {
      headerMain.classList.remove("header-main--white")
    }
  }

  // Add the scroll event listener
  window.addEventListener("scroll", handleScroll)

  // Initial check in case the page is already scrolled up
  handleScroll()

  // Check if the section Hero element exists and has the .section__hero class
  if (isLight) {
    // Add the .header-main--light class if .section__hero is present
    headerMain.classList.add("header-main--light")
  } else {
    // Remove the .header-main--light class if .section__hero is not present
    headerMain.classList.remove("header-main--light")
  }

  // On Funds page - Anchor menu - when I scroll the main menu is hidden and when I scroll up it appears
  let lastScrollY = window.scrollY
  let accumulatedScrollUpDistance = 0
  let accumulatedScrollDownDistance = 0
  const scrollUpThreshold = 500 // Adjust the threshold as needed
  const scrollDownThreshold = 500 // Adjust the threshold as needed

  window.addEventListener("scroll", () => {
    const currentScrollY = window.scrollY

    if (currentScrollY < lastScrollY) {
      // Scrolling up
      accumulatedScrollDownDistance = 0 // Reset the accumulated distance for scrolling down
      accumulatedScrollUpDistance += lastScrollY - currentScrollY
      if (accumulatedScrollUpDistance > scrollUpThreshold) {
        headerMain.classList.remove("hide-top-menu")
        accumulatedScrollUpDistance = 0 // Reset the accumulated distance
      }
    } else {
      // Scrolling down
      accumulatedScrollUpDistance = 0 // Reset the accumulated distance for scrolling up
      accumulatedScrollDownDistance += currentScrollY - lastScrollY
      if (accumulatedScrollDownDistance > scrollDownThreshold) {
        headerMain.classList.add("hide-top-menu")
        accumulatedScrollDownDistance = 0 // Reset the accumulated distance
      }
    }

    lastScrollY = currentScrollY
  })

  // Highlight the anchor of the section in view
  const menuItems = document.querySelectorAll('.nav-anchors a[href^="#"]')

  menuItems.forEach((item) => {
    const sectionId = item.getAttribute("href").slice(1)
    const section = document.getElementById(sectionId)
    if (!section) return

    ScrollTrigger.create({
      trigger: section,
      start: "top center-=150",
      end: "bottom center-=150",
      onEnter: () => {
        highlightMenuItem(item)
      },
      onEnterBack: () => {
        highlightMenuItem(item)
      },
      onLeave: () => {
        removeHighlight(item)
      },
      onLeaveBack: () => {
        removeHighlight(item)
      },
      scrub: 1,
    })

    item.addEventListener("click", (event) => {
      event.preventDefault()
      const offset = 100
      const sectionTop =
        section.getBoundingClientRect().top + window.scrollY - offset
      window.scrollTo({ top: sectionTop, behavior: "smooth" })
    })
  })

  function highlightMenuItem(item) {
    if (!item.classList.contains("highlighted")) {
      item.classList.add("highlighted")
      updateHighlightLine()
    }
  }

  function removeHighlight(item) {
    if (item.classList.contains("highlighted")) {
      item.classList.remove("highlighted")
    }
  }

  menuItems.forEach((item) => {
    item.addEventListener("click", (e) => {
      highlightMenuItem(e.target)
    })
  })

  function updateHighlightLine() {
    const activeItem = document.querySelector(".nav-anchors a.highlighted span")
    const anchorsNav = document.querySelector(".nav-anchors")
    const anchorsContainer = document.querySelector(".nav-anchors__container")
    const highlightLine = document.querySelector(".highlight-line")

    if (activeItem && highlightLine) {
      const itemRect = activeItem.getBoundingClientRect()
      let menuRect

      // Conditional check for screen width
      if (window.innerWidth < 1024) {
        menuRect = anchorsContainer.getBoundingClientRect()
      } else {
        menuRect = anchorsNav.getBoundingClientRect()
      }

      if (itemRect.width > 0 && itemRect.height > 0) {
        highlightLine.style.left = `${itemRect.left - menuRect.left}px`
        highlightLine.style.width = `${itemRect.width}px`

        // Ensure the highlighted item is visible within the horizontal scrollable menu
        activeItem.scrollIntoView({ behavior: "smooth", inline: "center" })
      }
    }
  }

  // Initial update
  updateHighlightLine()

  // Update on window resize
  window.addEventListener("resize", updateHighlightLine)

  // Update on scroll
  window.addEventListener("scroll", () => {
    // Ensure the active item is updated based on scroll position
    const menuItems = document.querySelectorAll('.nav-anchors a[href^="#"]')
    menuItems.forEach((item) => {
      const sectionId = item.getAttribute("href").slice(1)
      const section = document.getElementById(sectionId)
      if (!section) return
      const sectionRect = section.getBoundingClientRect()
      if (
        sectionRect.top <= window.innerHeight / 2 &&
        sectionRect.bottom >= window.innerHeight / 2
      ) {
        item.classList.add("highlighted")
      } else {
        item.classList.remove("highlighted")
      }
    })

    updateHighlightLine()
  })

  // If we are on desktop we don't want to have body fixed even if the menu was open on mobile
  function removeFixedClassOnResize() {
    if (
      window.innerWidth > 1024 &&
      document.body.classList.contains("menu-is-open")
    ) {
      document.body.style.position = ""
    }
  }

  // Call the function to activate the resize listener
  window.addEventListener("resize", removeFixedClassOnResize)
}
